import { Injectable, signal } from '@angular/core';
import { LoginMethod } from './api/types';

export type LoginChallengeInformation = {
  username: string | null;
  password: string | null;
  loginMethods: LoginMethod[];
};

@Injectable({
  providedIn: 'root',
})
export class LoginChallengeService {
  private readonly _loginChallengeInfo = signal<LoginChallengeInformation>({
    username: null,
    password: null,
    loginMethods: [],
  });
  readonly loginChallengeInfo = this._loginChallengeInfo.asReadonly();

  setInformation(info: LoginChallengeInformation): void {
    this._loginChallengeInfo.set(info);
  }
}
